// react
import React from "react";
import {Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, XAxis, YAxis, Tooltip} from "recharts";

// local
import {ResourceGroup} from "../types";
import {TOOLTIP_STYLE} from "../types";

/**
 * Annual Engagement
 */

interface EngagementsProps {
	chartId: string,
	chartName: string,
	totals2: number[],
	ctlMonths: string[]
}
interface EngagementsState {
}

export class AnnualEngagements extends React.Component<EngagementsProps, EngagementsState> {

	tooltip = ({ active, payload }: any) => {
		// setup
		const {chartId} = this.props;

		// render
		if (active && payload && payload.length) {
			return (
				<div className="tip-custom">
					<div className="tip-title">{payload[0].payload.name}</div>
					<div className="tip-this-year"> {payload[0].value}</div>
				</div>
			);
		}
		return null;
	};

	yAxis = (tickItem: any) => {
		return tickItem.toString();
	};

	render() {
		// Construct the list.
		const {chartName, totals2, ctlMonths} = this.props;
		const yearId = (new Date()).getFullYear().toString();

		const stats = [];
		for (let i = 0; i < 12; i++) {
			stats.push({name: ctlMonths[i], year2: totals2[i]});
		}

		// render
		return (
			<div id="AnnualStats" className="section">
				<h4 className="title">{chartName}</h4>
				<ResponsiveContainer width="100%" height={300}>
					<BarChart width={200} height={100} data={stats}>
						<CartesianGrid strokeDasharray="3 3" vertical={false}/>
						<Bar dataKey={'year2'} name={yearId} fill="#31a5a4"/>
						<YAxis
							label={{ value: 'Monthly Total', angle: -90, position: 'insideLeft' }}
							tickFormatter={this.yAxis}
						/>
						<Legend />
						<XAxis
							dataKey="name"
							fontFamily="sans-serif"
							label={{ value: ''}}
							dy='25'
						/>
						<Tooltip content={this.tooltip} wrapperStyle={TOOLTIP_STYLE} cursor={{fill: '#3880ff54'}}/>
					</BarChart>
				</ResponsiveContainer>
			</div>
		);
	}

}

